import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PushNotificationService } from '@notification/push-notification.service';
import { SelectionModel } from '@angular/cdk/collections';
import { NotificationTag } from '@common/select-notification-dialog/notifcation-tag.model';
import { Location } from '@angular/common';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { SELECT_START_END_DATE_ERROR } from '@root/app.constant';

@Component({
  selector: 'app-push-notification-history',
  templateUrl: './push-notification-history.component.html',
  styleUrls: ['./push-notification-history.component.scss'],
  providers: [PushNotificationService],
})
export class PushNotificationHistoryComponent implements OnInit {
  tagList: any;
  tagSelection = new SelectionModel<NotificationTag>(true, []);
  filterParams = new FilterParamter();
  constructor(
    private router: Router,
    private pushnotificationService: PushNotificationService,
    private location: Location,
    private toastr: ToastrService
  ) {}

  historyNotifications = [];

  startDate: Date = new Date();

  endDate: Date = new Date();

  today = new Date();

  ngOnInit() {
    this.readAllTagNotifications();
    this.readNotificationHistory();
  }

  public readAllTagNotifications() {
    this.pushnotificationService.readAllNotificationTags().subscribe(
      (response) => {
        this.tagList = response.data.tag;
      },
      (error) => {}
    );
  }
  public onSelectTags() {
    this.tagList.forEach((tag) => this.tagSelection.select(tag));
  }

  /****RIGHT */
  public pageBack() {
    this.router.navigate(['/home', 'push-notifications'], {
      queryParams: { tabindex: 1 },
    });
  }

  readNotificationHistory() {
    if(this.startDate === null && this.endDate === null){
      this.toastr.error(SELECT_START_END_DATE_ERROR)
    } else {
    const selectedTags = this.tagSelection.selected || [];
    this.filterParams.tags = [];
    if (this.startDate && this.endDate) {
      this.filterParams.startDate = moment(this.startDate).format('DD/MM/YYYY');
      this.filterParams.endDate = moment(this.endDate).format('DD/MM/YYYY');
    }
    selectedTags.forEach((tag) => this.filterParams.tags.push(tag.id));
    this.pushnotificationService
      .readNotificationHistory(this.filterParams)
      .subscribe(
        (response) => {
          this.historyNotifications = response.data.list || [];
          this.resetDate();
        },
        (error) => {}
      );
    }
  }

  public resetDate(){
    this.startDate = null;
    this.endDate = null;
  }
}

export class FilterParamter {
  startDate: string;
  endDate: string;
  tags: number[];
  constructor() {
    this.startDate = new Date().toISOString();
    this.endDate = new Date().toISOString();
    this.tags = [];
  }
}
